import { getAuthAxiosBackend } from "@/helpers/axios"

class FileNamesServices {
    get(id) {
        return getAuthAxiosBackend().get('FileNames/getFileNamesById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('FileNames/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('FileNames/addFileName', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('FileNames/updateFileName/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('FileNames/restoreFileName' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('FileNames/softDeleteFileName/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('FileNames/deleteFileName/' + id.toString())
    }
}

export default new FileNamesServices()
